import { DisplayObject } from "pixi.js";
import { Box } from "./Box";

export class VBox extends Box {
    public override get width(): number {
        return Math.max(...this.children.map((child) => (child.visible ? child.getLocalBounds()?.width ?? 0 : 0) * child.scale.x));
    }

    public override get height(): number {
        const visibleChildren = this.children.filter((child) => child.visible);
        return visibleChildren.map((child) => this.getDisplayObjectHeight(child)).reduce((partialSum, a) => partialSum + a, 0) + (visibleChildren.length - 1) * this.childSpacing;
    }

    private childSpacingProperty: number;

    public get childSpacing(): number {
        return this.childSpacingProperty;
    }

    public set childSpacing(v: number) {
        this.childSpacingProperty = v;
        this.dirty = true;
        this.alignChildren();
    }

    constructor(childSpacing: number = 10) {
        super();
        this.childSpacingProperty = childSpacing;
    }

    public override alignmentStrategy() {
        let positionY = 0.0;
        for (let i = 0; i < this.children.length; i++) {
            let child = this.children[i];
            child.position.y = positionY;
            const height = this.getDisplayObjectHeight(child);
            positionY += height > 0 ? height + this.childSpacing : 0;
        }
    }

    private getDisplayObjectHeight(component: DisplayObject): number {
        if (!component.visible) {
            return 0;
        }
        const localBounds = component?.getLocalBounds();
        if (localBounds?.height != null) {
            return localBounds.height * component.scale?.y ?? 1;
        }
        const anonymComponent = <any>component;
        if (anonymComponent["height"] != null) {
            return anonymComponent["height"];
        }
        return 0;
    }
}
